// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-vid-area {
    border: 1px dotted black;
    border-radius: 10px;
    padding: 28px 15px;
    margin: 15px;
}

.record-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    margin: 1rem 0;
}

::ng-deep .editorType .form-check-input:checked{
    background-color: #6c2fbb !important;
    border-color: #6c2fbb !important;
}

.betaTag {
    color: red;
}

.contentTitle{
    border-bottom: 1px solid #dfdddd;
    margin-bottom: 10px;
    padding-bottom: 12px;
}
.okBtnLine{
    border-top: 1px solid #dfdddd;
    min-height: auto;
}
.btnOk{
    border: 1px solid #6e5eff;
    padding: 7px 30px;
    border-radius: 5px;
    color: #ffff;
    font-size: 15px;
    cursor: pointer;
    background: #6e5eff;
    text-align: center;
    margin-right: 10px;
}

.preview-video-list-inner li {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
}
.preview-video-list-inner h6 {
    font-size: 14px;
}
.preview-video-list-inner img {
    cursor: pointer;
    flex-shrink: 0;
}
.preview-video-list-inner .preview-video-icon {
    width: 45px;
    height: 45px;
    background-color: #f1eafe;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-shrink: 0;
}

.preview-video-container{
    height: 100%;
    max-height: 337px;
    overflow: auto;
}

::ng-deep .cdk-overlay-container:has(.minimized-modal) .cdk-overlay-dark-backdrop {
    display: none;
}
/* .cdk-global-scrollblock {
    position: fixed;
    width: 100%;
    overflow-y: scroll;
} */
::ng-deep html:has(.minimized-modal).cdk-global-scrollblock {
    position: unset;
}
::ng-deep .minimized-modal {
    max-width: 400px !important;
    box-shadow: 0 0 14px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid #ddd;
    border-radius: 10px
}
::ng-deep .minimized-modal .select-vid-area {
    margin: 0 !important;
    padding: 15px;
}
::ng-deep .minimized-modal p {
    font-size: 14px;
    margin-bottom: 7px;
}
::ng-deep .minimized-modal span {
    font-size: 14px;
}
::ng-deep .minimize-maximize {
    width: 30px;
    height: 30px;
    cursor: pointer;
    background-color: rgba(122, 45, 249, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    border-radius: 6px;
}
::ng-deep .minimize-maximize.active-position {
    background-color: #6c2fbb;
}
::ng-deep .minimize-maximize.active-position svg path {
    fill: #ffffff;
}
::ng-deep .minimize-maximize img {
    width: 22px;
    height: 22px;
}
::ng-deep .cdk-overlay-container:has(.recordSection) .create-video-modal {
    visibility: hidden;
}

.redirectLink p{
    font-size: 16px !important;
    margin-bottom: 0;
    padding: 10px 0;
}
.redirectLink p a{
    font-weight: 500;
    color: #6013c3;
    font-size: 17px;
}

.custom-switch {
    margin-left: 36px;
}

/* DRAG CSS */
.draggable-container {
    position: relative;
    cursor: move;
}

.cdk-drag-handle {
    position: absolute;
    top: 0;
    right: 0;
    color: #ccc;
    cursor: move;
    padding: 8px;
    z-index: 100;
}

/* // This helps with the dragging visual feedback */
.cdk-drag-dragging {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

/* // Reset the default mat-dialog styles that prevent dragging */
::ng-deep .draggable-dialog .mat-dialog-container {
    padding: 0;
    overflow: visible;
}

.form-check-input {
    background-color: rgba(122, 45, 249, 0.1);
    border: rgba(122, 45, 249, 0.1);
}

.form-check-input:checked {
    background-color: #6e5eff;
    border-color: #6e5eff;
    --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e") !important;
}

.form-switch .form-check-input{
    --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e") !important;
}

.form-switch .form-check-input:focus {
    --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e") !important;
}

@media (max-width: 991px) and (max-height: 430px) {
    .video-js {
        height: 80vh !important;
    }
}
@media (max-width: 768px) {
    .video-js {
        width: 100% !important;
        height: 60vh;
    }
}

@media (max-width: 360px) {
     ::ng-deep .mat-dialog-actions{
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
      }
}`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/record-video/record-video.component.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;;;;GAIG;AACH;IACI,eAAe;AACnB;AACA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;IACtB;AACJ;AACA;IACI,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yCAAyC;IACzC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA,oDAAoD;AACpD;IACI,yCAAyC;AAC7C;;AAEA,iEAAiE;AACjE;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,qKAAqK;AACzK;;AAEA;IACI,qKAAqK;AACzK;;AAEA;IACI,qKAAqK;AACzK;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;;AAEA;KACK;YACO,sBAAsB;YACtB,uBAAuB;YACvB,SAAS;MACf;AACN","sourcesContent":[".select-vid-area {\n    border: 1px dotted black;\n    border-radius: 10px;\n    padding: 28px 15px;\n    margin: 15px;\n}\n\n.record-controls {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n    margin: 1rem 0;\n}\n\n::ng-deep .editorType .form-check-input:checked{\n    background-color: #6c2fbb !important;\n    border-color: #6c2fbb !important;\n}\n\n.betaTag {\n    color: red;\n}\n\n.contentTitle{\n    border-bottom: 1px solid #dfdddd;\n    margin-bottom: 10px;\n    padding-bottom: 12px;\n}\n.okBtnLine{\n    border-top: 1px solid #dfdddd;\n    min-height: auto;\n}\n.btnOk{\n    border: 1px solid #6e5eff;\n    padding: 7px 30px;\n    border-radius: 5px;\n    color: #ffff;\n    font-size: 15px;\n    cursor: pointer;\n    background: #6e5eff;\n    text-align: center;\n    margin-right: 10px;\n}\n\n.preview-video-list-inner li {\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    padding: 10px;\n    margin-bottom: 10px;\n}\n.preview-video-list-inner h6 {\n    font-size: 14px;\n}\n.preview-video-list-inner img {\n    cursor: pointer;\n    flex-shrink: 0;\n}\n.preview-video-list-inner .preview-video-icon {\n    width: 45px;\n    height: 45px;\n    background-color: #f1eafe;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n.preview-video-container{\n    height: 100%;\n    max-height: 337px;\n    overflow: auto;\n}\n\n::ng-deep .cdk-overlay-container:has(.minimized-modal) .cdk-overlay-dark-backdrop {\n    display: none;\n}\n/* .cdk-global-scrollblock {\n    position: fixed;\n    width: 100%;\n    overflow-y: scroll;\n} */\n::ng-deep html:has(.minimized-modal).cdk-global-scrollblock {\n    position: unset;\n}\n::ng-deep .minimized-modal {\n    max-width: 400px !important;\n    box-shadow: 0 0 14px 4px rgba(0, 0, 0, 0.1);\n    border: 1px solid #ddd;\n    border-radius: 10px\n}\n::ng-deep .minimized-modal .select-vid-area {\n    margin: 0 !important;\n    padding: 15px;\n}\n::ng-deep .minimized-modal p {\n    font-size: 14px;\n    margin-bottom: 7px;\n}\n::ng-deep .minimized-modal span {\n    font-size: 14px;\n}\n::ng-deep .minimize-maximize {\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n    background-color: rgba(122, 45, 249, 0.1);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 0;\n    border-radius: 6px;\n}\n::ng-deep .minimize-maximize.active-position {\n    background-color: #6c2fbb;\n}\n::ng-deep .minimize-maximize.active-position svg path {\n    fill: #ffffff;\n}\n::ng-deep .minimize-maximize img {\n    width: 22px;\n    height: 22px;\n}\n::ng-deep .cdk-overlay-container:has(.recordSection) .create-video-modal {\n    visibility: hidden;\n}\n\n.redirectLink p{\n    font-size: 16px !important;\n    margin-bottom: 0;\n    padding: 10px 0;\n}\n.redirectLink p a{\n    font-weight: 500;\n    color: #6013c3;\n    font-size: 17px;\n}\n\n.custom-switch {\n    margin-left: 36px;\n}\n\n/* DRAG CSS */\n.draggable-container {\n    position: relative;\n    cursor: move;\n}\n\n.cdk-drag-handle {\n    position: absolute;\n    top: 0;\n    right: 0;\n    color: #ccc;\n    cursor: move;\n    padding: 8px;\n    z-index: 100;\n}\n\n/* // This helps with the dragging visual feedback */\n.cdk-drag-dragging {\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n/* // Reset the default mat-dialog styles that prevent dragging */\n::ng-deep .draggable-dialog .mat-dialog-container {\n    padding: 0;\n    overflow: visible;\n}\n\n.form-check-input {\n    background-color: rgba(122, 45, 249, 0.1);\n    border: rgba(122, 45, 249, 0.1);\n}\n\n.form-check-input:checked {\n    background-color: #6e5eff;\n    border-color: #6e5eff;\n    --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\") !important;\n}\n\n.form-switch .form-check-input{\n    --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\") !important;\n}\n\n.form-switch .form-check-input:focus {\n    --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\") !important;\n}\n\n@media (max-width: 991px) and (max-height: 430px) {\n    .video-js {\n        height: 80vh !important;\n    }\n}\n@media (max-width: 768px) {\n    .video-js {\n        width: 100% !important;\n        height: 60vh;\n    }\n}\n\n@media (max-width: 360px) {\n     ::ng-deep .mat-dialog-actions{\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 10px;\n      }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
